import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { MrDriveAvatar } from "@/components/MrDriveAvatar";
import { SECTION_HINTS, type SectionHintKey } from "@/lib/first-steps-copy";
import { dismissHint, hintDismissed } from "@/lib/first-steps-flags";

/** Подсказка MrDrive при первом входе в раздел. Закрывается крестиком и больше не показывается. */
export function SectionHint({ hint, className = "" }: { hint: SectionHintKey; className?: string }) {
  const [show, setShow] = useState(false);
  useEffect(() => setShow(!hintDismissed(hint)), [hint]);
  if (!show) return null;
  return (
    <div className={`relative flex items-center gap-3 rounded-2xl bg-td-soft/60 p-3 pr-11 ${className}`}>
      <MrDriveAvatar variant="people" size={40} borderWidth={3} />
      <p className="min-w-0 text-sm text-td-dark">{SECTION_HINTS[hint]}</p>
      <button
        type="button"
        aria-label="Закрыть подсказку"
        onClick={() => {
          dismissHint(hint);
          setShow(false);
        }}
        className="absolute right-1 top-1 flex size-10 items-center justify-center rounded-full text-td-muted hover:bg-td-soft"
      >
        <X className="size-4" />
      </button>
    </div>
  );
}
